import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { MainLayout } from '@agentguru/layout';
import { WaitModule } from '@agentguru/components';
import { AppNavBar } from '../AppNavBar';
export function Shell() {
    return (_jsxs(MainLayout, { children: [_jsx(AppNavBar, {}), _jsx(WaitModule, { children: _jsx(Outlet, {}) })] }));
}
